import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import {
  selectWorkflow,
  selectWorkflowMIsIdVerificationAttemptsMaxed,
  selectPEPStatus,
  selectIsPotentialAMLIdentified,
} from '../../../selectors';
import { restartWorkflow } from './actions';
import Steps from './Component';

const mapStateToProps = createSelector(
  selectWorkflow,
  selectWorkflowMIsIdVerificationAttemptsMaxed,
  selectPEPStatus,
  selectIsPotentialAMLIdentified,
  (workflow, isIdVerificationAttemptsMaxed, pepStatus, isPotentialAMLIdentified) => ({
    workflow,
    isIdVerificationAttemptsMaxed,
    pepStatus,
    isPotentialAMLIdentified,
  }),
);

function mapDispatchToProps(dispatch) {
  return {
    restart: (location) => dispatch(restartWorkflow(location)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Steps);
